import algoliaSearch from "algoliasearch";
import { compact } from "lodash";
import { PRODUCTION } from "@irati/utils/constants/environment";
import { hasValidValues } from "@irati/geolocation/src/helpers/latLng";
import env from "@irati/utils/env";
var places = null;
var convertAlgoliaPlacesHitToLatLng = function (hit) {
    return {
        lat: hit._geoloc.lat,
        lng: hit._geoloc.lng
    };
};
export var getPlaceSuggestions = function (query, centerLatLng, locales) {
    if (!places) {
        var isProduction = env.ENVIRONMENT_NAME === PRODUCTION;
        var PLACES_APP_ID = isProduction ? "plM2ADJDO5QQ" : "pl6N1KFFNQFW";
        var PLACES_API_KEY = isProduction ? "b26c88f521cf1558974104508d3e4ddc" : "94af8a6a000b101333fe1e466963abd3";
        // @ts-ignore
        // method is missing in definition file
        places = algoliaSearch.initPlaces(PLACES_APP_ID, PLACES_API_KEY);
    }
    var searchParams = {
        query: query
    };
    if (centerLatLng && hasValidValues(centerLatLng.lat, centerLatLng.lng)) {
        searchParams.aroundLatLng = centerLatLng.lat + ", " + centerLatLng.lng;
    }
    var countryCodes = locales.reduce(function (acc, locale) {
        var countryCode = locale.split("-")[1];
        if (countryCode) {
            acc.push(countryCode.toLowerCase());
        }
        return acc;
    }, []);
    if (countryCodes.length > 0) {
        searchParams.countries = countryCodes;
    }
    return places.search(searchParams).then(function (results) {
        return results.hits.map(function (hit) {
            var locale_names = hit.locale_names, county = hit.county, postcode = hit.postcode, country = hit.country;
            var part1 = locale_names ? locale_names.default.join(", ") : "";
            var part2 = county ? county.default.join(", ") : "";
            var part3 = postcode && Array.isArray(postcode) && postcode.length === 1 ? postcode[0] : "";
            var part4 = country ? country.default : "";
            var desc = compact([part1, part2, part3, part4]).join(", ");
            var latLng = convertAlgoliaPlacesHitToLatLng(hit);
            return Object.assign({ desc: desc }, latLng);
        });
    });
};
